<template>
    <div class="card-container">
        <div class="card-header">
            <div class="informations-container">
                <div class="name-header">
                    <p class="information-title">NAME</p>
                    <strong class="infos">{{blankingProfile.display_name}}</strong>
                </div>
                <div class="name-header">
                    <p class="information-title">REGION</p>
                    <div>
                        <strong
                            v-if="blankingProfile.aws_region"
                            class="infos"
                        >
                            {{blankingProfile.aws_region.verbose_name}}
                        </strong>
                        <strong
                            v-else
                            class="infos"
                        >
                            No Region for this profile
                        </strong>
                    </div>
                </div>
            </div>
            <div class="buttons-container">
                <el-button
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    @click="editProfile(blankingProfile)">
                </el-button>
                <el-tooltip
                    :disabled="!hasRelatedTakers"
                    class="item"
                    effect="dark"
                    content="You can't delete a profile if takers have rights"
                    placement="bottom"
                >
                    <el-popconfirm
                        confirm-button-text='OK'
                        cancel-button-text='No'
                        icon="el-icon-info"
                        icon-color="red"
                        popper-class="gcmcn-popper"
                        title="Are you sure to delete this profile?"
                        @confirm="deleteScheduling"
                    >
                        <el-button
                            slot="reference"
                            size="mini"
                            type="danger"
                            icon="el-icon-delete"
                            :disabled="hasRelatedTakers"
                        >
                        </el-button>
                    </el-popconfirm>
                </el-tooltip>
            </div>
        </div>
        <div class="informations">
            <div class="information-block">
                <p class="information-title">TAKERS</p>
                <div v-if="blankingProfile.takers.length > 0" class="informations-list">
                    <div
                        v-for="taker in blankingProfile.takers"
                        :key="taker.uid"
                    >
                        <strong class="info-name"> {{taker.name}}  </strong>
                    </div>
                </div>
                <div v-else>
                    <strong>No takers related to this profile</strong>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    name: 'profile-card',
    props:{
        blankingProfile:{
            type: Object,
            reqiured: true
        },
    },
    data () {
        return {
            loading: false,
        };
    },
    computed: {
        hasRelatedTakers(){
            if(this.blankingProfile.takers.length > 0){
                return true;
            }
            return false;
        }
    },
    mounted(){
    },
    methods: {
        editProfile(selectedProfile){
            this.$emit('edit-profile', selectedProfile);
        },
        deleteScheduling(){
            this.$store.dispatch('patchItem', {
                item: {
                    uid: this.blankingProfile.uid,
                    url: this.blankingProfile.url,
                    archived: true,
                },
                model: 'blankingProfiles'
            }).then(() => {
                this.$notify.success({
                    title: 'Success',
                    message: 'Profile has been deleted'
                });
                this.$emit('on-archived-reload');
            }).catch(() => {
                this.$notify.error({
                    title: 'Error',
                    message: 'Profile couldn\'t be deleted'
                });
            });

        },

    }
};
</script>

<style lang="css" scoped>
.card-container{
    background-color: #222223;
    padding: 1em;
    margin-bottom: 1em;

}
.card-header{
    display: flex;
    justify-content: space-between;
}
.day-information{
    font-weight: bold;
    font-size: 16px;
}
.informations{
    display: flex;
    justify-content: space-between;
    margin-top: 2em;
}
.information-title{
    text-transform: uppercase;
    font-size: 11px;
    color: #BBBBBB;
    margin-bottom: 0.2em;
}
.small{
    font-family: 'roboto';
    font-size: 9px;
    font-weight: normal;
    margin-top: 0.3em;
    margin-left: 0.5em;
    margin-bottom: 0;
}
.infos{
    font-weight: bold;
    font-size: 12px;
    display: block;
}
.infos-container{
    display: flex;
}
.name-header{
    margin-right: 2em;
    margin-top: 1em;
}
.informations-list{
    display: flex;
    flex-wrap: wrap;
}
.info-name{
    margin-right: 2em;
}
.informations-container{
    display: flex;
    justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Channels/Profiles/profile-card.vue